import React, { useState } from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import { PresentationStatus } from '../types';
import { COPY, statusLabel } from '../presentationCopy';
import { allowedStatusTransitions, statusActionLabel } from '../statusTransitions';
import { Pill } from '../ui';
import { pillToneForStatus } from '../ui/pillTone';

interface StatusMenuProps {
  status: PresentationStatus;
  permissions: string[];
  disabled?: boolean;
  onChange: (status: PresentationStatus) => void;
}

const StatusMenu: React.FC<StatusMenuProps> = ({ status, permissions, disabled, onChange }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const actions = allowedStatusTransitions(status, permissions);

  return (
    <>
      <Box
        component="button"
        type="button"
        disabled={disabled || !actions.length}
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{
          border: 0,
          bgcolor: 'transparent',
          p: 0,
          cursor: disabled || !actions.length ? 'default' : 'pointer',
        }}
      >
        <Pill tone={pillToneForStatus(status)}>{statusLabel(status)}</Pill>
      </Box>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {actions.map((next) => (
          <MenuItem
            key={next}
            onClick={() => {
              setAnchor(null);
              onChange(next);
            }}
          >
            {statusActionLabel(status, next, COPY)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default StatusMenu;
